import { Priority } from '../Priority';


export class PrioritySerializer {
    fromJson(json: any): Priority {
        const data = new Priority();
        data.value = json.id;
        data.label = json.name;
        data.sourceName=json.sourceName ? json.sourceName :json.lastName ? json.firstName +" "+json.lastName: json.firstName;
        data.id=json.id;
        return data;
    }

    toJson(data: Priority): any {
        return {
            id: data.id,
            name: data.name
        };
    }
}